import { render } from "./StreetAddressFormSimple.vue?vue&type=template&id=40e24c39&ts=true"
import script from "./StreetAddressFormSimple.vue?vue&type=script&lang=ts"
export * from "./StreetAddressFormSimple.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__